import React from 'react';

// Renders a status choice: divider entries render as an unselectable group
// separator (parrot-media/portal/main#290), and the Needs Review entry shows
// in red with its count when the queue is non-empty (#293)
const StatusChoiceText = ({record}) => {
    if (record && record.divider) {
        return (
            <span style={{
                display: 'block',
                width: '100%',
                borderTop: '1px solid #bdbdbd',
                color: '#757575',
                fontSize: 12,
                letterSpacing: 1,
                textTransform: 'uppercase',
                paddingTop: (record.name) ? 2 : 0
            }}>
                {record.name}
            </span>
        );
    }
    return (
        <span style={(record && record.alert) ? {color: '#d32f2f', fontWeight: 600} : undefined}>
            {(record) ? record.name : ''}
        </span>
    );
};

export default StatusChoiceText;
